import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import { FiEye, FiEyeOff, FiUser, FiHome, FiMail, FiLock, FiTag } from 'react-icons/fi';

const RegisterForm = () => {
  const [regMode, setRegMode] = useState('user'); // 'user' = Versenyző, 'club' = Egyesület
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState(''); // Felhasználó neve vagy Egyesület neve
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // 1. Regisztráció az Authentication-be
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. Kollekció meghatározása
      const collectionName = regMode === 'user' ? 'users' : 'Clubs';
      
      // Adatok összeállítása
      const userData = {
        uid: user.uid,
        email: user.email,
        createdAt: serverTimestamp(),
        role: regMode
      };

      // Név mentése a megfelelő mezőnévvel
      if (regMode === 'user') {
        userData.displayName = name;
      } else {
        userData.clubName = name;
      }

      // 3. Mentés Firestore-ba (users/{uid} VAGY Clubs/{uid})
      await setDoc(doc(db, collectionName, user.uid), userData);

      console.log(`✅ Sikeres regisztráció a ${collectionName} kollekcióba!`);
      
      // Átirányítás
      navigate(regMode === 'club' ? '/egyesulet-dashboard' : '/profil'); 
    } catch (err) {
      console.error('❌ Hiba:', err.message);
      switch (err.code) {
        case 'auth/email-already-in-use':
          setError('Ez az email cím már használatban van');
          break;
        case 'auth/invalid-email':
          setError('Érvénytelen email cím');
          break;
        case 'auth/weak-password':
          setError('A jelszónak legalább 6 karakter hosszúnak kell lennie');
          break;
        default:
          setError('Hiba történt a regisztráció során');
      }
    } finally {
      setLoading(false);
    }
  };

  // Fül stílusok (ugyanaz mint a Loginnál)
  const tabStyle = (mode) => ({
    flex: 1,
    padding: '15px',
    cursor: 'pointer',
    border: 'none',
    fontSize: '1rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: '0.3s',
    backgroundColor: regMode === mode ? '#fff' : '#f2f2f2',
    color: regMode === mode ? '#b30000' : '#666',
    borderBottom: regMode === mode ? 'none' : '2px solid #b30000',
    borderRadius: mode === 'user' ? '12px 0 0 0' : '0 12px 0 0',
  });

  return (
    <main style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', maxWidth: '450px', margin: '40px auto' }}>
      <div style={{ 
        backgroundColor: '#fff', 
        borderRadius: '12px', 
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)', 
        overflow: 'hidden',
        padding: '40px 20px',
        textAlign: 'center'
      }}>
        <FiLock size={50} color="#b30000" style={{ marginBottom: '20px' }} />
        <h2 style={{ color: '#b30000', marginBottom: '15px' }}>Regisztráció szünetel</h2>
        <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '25px' }}>
          A weboldal jelenleg privát béta tesztelés alatt áll.
          A regisztráció átmenetileg szünetel.
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            backgroundColor: '#b30000',
            color: 'white',
            padding: '10px 25px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 'bold'
          }}
        >
          Vissza a főoldalra
        </Link>
      </div>
    </main>
  );
};

export default RegisterForm;